import { summaryCards } from "@/mocks/dashboard";

const colorMap: Record<string, { bg: string; icon: string; text: string; badge: string }> = {
  emerald: { bg: "bg-emerald-50", icon: "text-emerald-600", text: "text-emerald-700", badge: "bg-emerald-100 text-emerald-700" },
  sky: { bg: "bg-sky-50", icon: "text-sky-600", text: "text-sky-700", badge: "bg-sky-100 text-sky-700" },
  amber: { bg: "bg-amber-50", icon: "text-amber-600", text: "text-amber-700", badge: "bg-amber-100 text-amber-700" },
  violet: { bg: "bg-violet-50", icon: "text-violet-600", text: "text-violet-700", badge: "bg-violet-100 text-violet-700" },
  orange: { bg: "bg-orange-50", icon: "text-orange-600", text: "text-orange-700", badge: "bg-orange-100 text-orange-700" },
};

export default function SummaryCards() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {summaryCards.map((card, i) => {
        const c = colorMap[card.color] || colorMap.emerald;
        return (
          <div
            key={i}
            className="bg-white rounded-2xl p-5 border border-gray-100 hover:shadow-md transition-shadow cursor-pointer group"
          >
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${c.bg} mb-4`}>
              <i className={`${card.icon} text-lg ${c.icon}`}></i>
            </div>
            <p className="text-2xl font-bold text-gray-900 mb-1">{card.value}</p>
            <p className="text-xs text-gray-500 leading-tight mb-3">{card.label}</p>
            <span className={`inline-flex items-center text-[10px] font-medium px-2 py-0.5 rounded-full ${c.badge}`}>
              {card.change}
            </span>
          </div>
        );
      })}
    </div>
  );
}